/**
 * Kannada (ಕನ್ನಡ) translations
 */
import { TranslationStrings } from '../types';

export const kn: TranslationStrings = {  common: {
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    error: 'ದೋಷ ಸಂಭವಿಸಿದೆ',
    retry: 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
    cancel: 'ರದ್ದುಮಾಡು',
    confirm: 'ದೃಢೀಕರಿಸಿ',
    back: 'ಹಿಂದೆ',
    next: 'ಮುಂದೆ',
    submit: 'ಸಲ್ಲಿಸಿ',
    done: 'ಮುಗಿದಿದೆ',
    close: 'ಮುಚ್ಚು',
    yes: 'ಹೌದು',
    no: 'ಇಲ್ಲ',
    required: 'ಅಗತ್ಯ',
    optional: 'ಐಚ್ಛಿಕ',
  },
  consent: {
    secureConsent: 'ಸುರಕ್ಷಿತ ಒಪ್ಪಿಗೆ',
    yourConsentRequired: 'ನಿಮ್ಮ ಒಪ್ಪಿಗೆ ಅಗತ್ಯ',
    consentingAs: 'ಆಗಿ ಒಪ್ಪಿಗೆ ನೀಡುತ್ತಿದ್ದಾರೆ',
    requestingOrg: 'ವಿನಂತಿಸುತ್ತಿರುವ ಸಂಸ್ಥೆ',
    dataBeingCollected: 'ಸಂಗ್ರಹಿಸಲಾಗುತ್ತಿರುವ ಡೇಟಾ',
    purposeOfProcessing: 'ಸಂಸ್ಕರಣೆಯ ಉದ್ದೇಶ',
    whatYouWillDo: 'ನೀವು ಏನು ಮಾಡುವಿರಿ',
    reviewDocuments: 'ದಾಖಲೆಗಳನ್ನು ಪರಿಶೀಲಿಸಿ',
    provideConsent: 'ಒಪ್ಪಿಗೆ ನೀಡಿ',
    documentsToRead: 'ಓದಬೇಕಾದ ದಾಖಲೆಗಳು',
    estimatedTime: 'ಅಂದಾಜು ಸಮಯ',
    minutes: 'ನಿಮಿಷಗಳು',
    startReview: 'ಪರಿಶೀಲನೆ ಪ್ರಾರಂಭಿಸಿ',
    yourRights: 'DPDP ಕಾಯ್ದೆ 2023 ಅಡಿಯಲ್ಲಿ ನಿಮ್ಮ ಹಕ್ಕುಗಳು',
    rightToAccess: 'ನಿಮ್ಮ ಡೇಟಾವನ್ನು ಪ್ರವೇಶಿಸುವ ಹಕ್ಕು',
    rightToCorrect: 'ನಿಮ್ಮ ಡೇಟಾವನ್ನು ಸರಿಪಡಿಸುವ ಹಕ್ಕು',
    rightToWithdraw: 'ಒಪ್ಪಿಗೆಯನ್ನು ಹಿಂತೆಗೆದುಕೊಳ್ಳುವ ಹಕ್ಕು',
    rightToGrievance: 'ದೂರು ಸಲ್ಲಿಸುವ ಹಕ್ಕು',
    stepOf: 'ಹಂತ {current} / {total}',
    pleaseReadCarefully: 'ದಯವಿಟ್ಟು ಒಪ್ಪಿಗೆ ನೀಡುವ ಮೊದಲು ಪ್ರತಿ ದಾಖಲೆಯನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ಓದಿ.',
    documentsReviewed: 'ಪರಿಶೀಲಿಸಿದ ದಾಖಲೆಗಳು',
    remaining: 'ಉಳಿದಿದೆ',
    allDocumentsReviewed: 'ಎಲ್ಲಾ ದಾಖಲೆಗಳನ್ನು ಪರಿಶೀಲಿಸಲಾಗಿದೆ!',
    clickToRead: 'ಓದಲು ಪ್ರತಿ ದಾಖಲೆಯ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ',
    proceedToConsent: 'ನೀವು ಒಪ್ಪಿಗೆ ನೀಡಲು ಮುಂದುವರಿಯಬಹುದು',
    markAsRead: 'ಓದಿದ್ದು ಎಂದು ಗುರುತಿಸಿ',
    continueReading: 'ಓದುವುದನ್ನು ಮುಂದುವರಿಸಿ',
    confirmConsent: 'ನಿಮ್ಮ ಒಪ್ಪಿಗೆಯನ್ನು ದೃಢೀಕರಿಸಿ',
    selectMethod: 'ಪರಿಶೀಲನೆ ವಿಧಾನವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    iAgreeToTerms: 'ನಾನು ಎಲ್ಲಾ ನಿಯಮಗಳು, ನೀತಿಗಳು ಮತ್ತು ಒಪ್ಪಿಗೆ ಒಪ್ಪಂದಗಳನ್ನು ಒಪ್ಪುತ್ತೇನೆ',
    readAllDocuments: 'ನನ್ನ ಒಪ್ಪಿಗೆ ಸ್ವಯಂಪ್ರೇರಿತವಾಗಿದೆ ಮತ್ತು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಹಿಂಪಡೆಯಬಹುದು ಎಂದು ನಾನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳುತ್ತೇನೆ',
    submitConsent: 'ಒಪ್ಪಿಗೆ ಸಲ್ಲಿಸಿ',
    submitting: 'ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...',
    digitalSignature: 'ಡಿಜಿಟಲ್ ಸಹಿ',
    smsVerification: 'SMS ಪರಿಶೀಲನೆ',
    emailVerification: 'ಇಮೇಲ್ ಪರಿಶೀಲನೆ',
    videoRecording: 'ವೀಡಿಯೊ ರೆಕಾರ್ಡಿಂಗ್',
    audioRecording: 'ಆಡಿಯೊ ರೆಕಾರ್ಡಿಂಗ್',
    checkboxConfirmation: 'ಚೆಕ್‌ಬಾಕ್ಸ್ ದೃಢೀಕರಣ',
    drawSignature: 'ನಿಮ್ಮ ಸಹಿಯನ್ನು ಬರೆಯಿರಿ',
    verifyViaSms: 'SMS ಕೋಡ್ ಮೂಲಕ ಪರಿಶೀಲಿಸಿ',
    verifyViaEmail: 'ಇಮೇಲ್ ಕೋಡ್ ಮೂಲಕ ಪರಿಶೀಲಿಸಿ',
    recordVideoConsent: 'ವೀಡಿಯೊ ಒಪ್ಪಿಗೆ ರೆಕಾರ್ಡ್ ಮಾಡಿ',
    recordAudioConsent: 'ಆಡಿಯೊ ಒಪ್ಪಿಗೆ ರೆಕಾರ್ಡ್ ಮಾಡಿ',
    confirmByChecking: 'ಚೆಕ್ ಮಾಡಿ ದೃಢೀಕರಿಸಿ',
    enterOtp: 'OTP ನಮೂದಿಸಿ',
    otpSentTo: 'OTP ಕಳುಹಿಸಲಾಗಿದೆ',
    resendOtp: 'OTP ಮತ್ತೆ ಕಳುಹಿಸಿ',
    verifyOtp: 'OTP ಪರಿಶೀಲಿಸಿ',
    otpVerified: 'OTP ಪರಿಶೀಲಿಸಲಾಗಿದೆ',
    invalidOtp: 'ಅಮಾನ್ಯ OTP',
    startRecording: 'ರೆಕಾರ್ಡಿಂಗ್ ಪ್ರಾರಂಭಿಸಿ',
    stopRecording: 'ರೆಕಾರ್ಡಿಂಗ್ ನಿಲ್ಲಿಸಿ',
    retake: 'ಮತ್ತೆ ತೆಗೆದುಕೊಳ್ಳಿ',
    recordingComplete: 'ರೆಕಾರ್ಡಿಂಗ್ ಪೂರ್ಣ',
    consentSubmitted: 'ಒಪ್ಪಿಗೆ ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ',
    thankYou: 'ಒಪ್ಪಿಗೆ ನೀಡಿದ್ದಕ್ಕೆ ಧನ್ಯವಾದಗಳು',
    confirmationSent: 'ನಿಮ್ಮ ಇಮೇಲ್‌ಗೆ ದೃಢೀಕರಣ ಕಳುಹಿಸಲಾಗಿದೆ',
    referenceNumber: 'ಉಲ್ಲೇಖ ಸಂಖ್ಯೆ',
    errorSubmitting: 'ಒಪ್ಪಿಗೆ ಸಲ್ಲಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    pleaseReadDocs: 'ದಯವಿಟ್ಟು ಮೊದಲು ಎಲ್ಲಾ ದಾಖಲೆಗಳನ್ನು ಓದಿ',
    pleaseProvideEvidence: 'ದಯವಿಟ್ಟು ಒಪ್ಪಿಗೆ ಪುರಾವೆ ನೀಡಿ',
  },
  documents: {
    privacyPolicy: 'ಗೌಪ್ಯತಾ ನೀತಿ',
    termsOfService: 'ಸೇವಾ ನಿಯಮಗಳು',
    consentAgreement: 'ಒಪ್ಪಿಗೆ',
    dataSharingAgreement: 'ಡೇಟಾ ಹಂಚಿಕೆ ಒಪ್ಪಂದ',
    cookiePolicy: 'ಕುಕೀ ನೀತಿ',
    retentionPolicy: 'ಡೇಟಾ ಧಾರಣ ನೀತಿ',
    gdprNotice: 'GDPR ಸೂಚನೆ',
    hipaaAuthorization: 'HIPAA ಅಧಿಕೃತತೆ',
    ccpaDisclosure: 'CCPA ಬಹಿರಂಗ',
    aadhaarAuthorization: 'ಆಧಾರ್ ಅಧಿಕೃತತೆ',
    customDocument: 'ಕಸ್ಟಮ್ ದಾಖಲೆ',
  },
  dataCategories: {
    personalInfo: 'ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ',
    contactDetails: 'ಸಂಪರ್ಕ ವಿವರಗಳು',
    financialInfo: 'ಆರ್ಥಿಕ ಮಾಹಿತಿ',
    healthData: 'ಆರೋಗ್ಯ ಮತ್ತು ವೈದ್ಯಕೀಯ ಡೇಟಾ',
    biometricData: 'ಬಯೋಮೆಟ್ರಿಕ್ ಡೇಟಾ',
    locationData: 'ಸ್ಥಳ ಡೇಟಾ',
    behavioralData: 'ನಡವಳಿಕೆ ಡೇಟಾ',
    communicationData: 'ಸಂವಹನ ಡೇಟಾ',
    employmentInfo: 'ಉದ್ಯೋಗ ಮಾಹಿತಿ',
    educationInfo: 'ಶೈಕ್ಷಣಿಕ ಮಾಹಿತಿ',
  },
  a11y: {
    mainContent: 'ಮುಖ್ಯ ವಿಷಯ',
    navigation: 'ನ್ಯಾವಿಗೇಶನ್',
    closeModal: 'ಮೋಡಲ್ ಮುಚ್ಚಿ',
    expandSection: 'ವಿಭಾಗ ವಿಸ್ತರಿಸಿ',
    collapseSection: 'ವಿಭಾಗ ಮುಚ್ಚಿ',
    documentRead: 'ದಾಖಲೆ ಓದಿದ್ದು ಎಂದು ಗುರುತಿಸಲಾಗಿದೆ',
    documentUnread: 'ದಾಖಲೆ ಇನ್ನೂ ಓದಿಲ್ಲ',
    progressIndicator: 'ಪ್ರಗತಿ: {current} / {total} ದಾಖಲೆಗಳನ್ನು ಓದಲಾಗಿದೆ',
    signaturePad: 'ಸಹಿ ಪ್ರದೇಶ',
    clearSignature: 'ಸಹಿ ತೆರವುಗೊಳಿಸಿ',
    videoPlayer: 'ವೀಡಿಯೊ ರೆಕಾರ್ಡಿಂಗ್ ಪ್ಲೇಯರ್',
    audioPlayer: 'ಆಡಿಯೊ ರೆಕಾರ್ಡಿಂಗ್ ಪ್ಲೇಯರ್',
    requiredField: 'ಈ ಕ್ಷೇತ್ರ ಅಗತ್ಯ',
    errorMessage: 'ದೋಷ',
    successMessage: 'ಯಶಸ್ಸು',
    loadingContent: 'ವಿಷಯ ಲೋಡ್ ಆಗುತ್ತಿದೆ, ದಯವಿಟ್ಟು ಕಾಯಿರಿ',
    newWindow: 'ಹೊಸ ವಿಂಡೋದಲ್ಲಿ ತೆರೆಯುತ್ತದೆ',
  },
  portal: {
    // General
    myConsents: 'ನನ್ನ ಒಪ್ಪಿಗೆಗಳು',
    viewManageConsents: 'ನಿಮ್ಮ ಒಪ್ಪಿಗೆ ದಾಖಲೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ ಮತ್ತು ನಿರ್ವಹಿಸಿ',
    logout: 'ಲಾಗ್‌ಔಟ್',
    welcomeBack: 'ಮರಳಿ ಸ್ವಾಗತ',
    
    // Tenant selector
    organizationNameOrCode: 'ಸಂಸ್ಥೆಯ ಹೆಸರು ಅಥವಾ ಕೋಡ್',
    orgPlaceholder: 'ಉದಾ., globalhealth ಅಥವಾ acme-corp',
    orgHint: 'ನಿಮ್ಮ ಸಂಸ್ಥೆ ಒದಗಿಸಿದ ಹೆಸರು ಅಥವಾ ಕೋಡ್ ನಮೂದಿಸಿ',
    findMyOrganization: 'ನನ್ನ ಸಂಸ್ಥೆಯನ್ನು ಹುಡುಕಿ',
    orgNotFound: 'ಸಂಸ್ಥೆ ಕಂಡುಬಂದಿಲ್ಲ. ದಯವಿಟ್ಟು ಹೆಸರು ಪರಿಶೀಲಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    enterOrgName: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಸಂಸ್ಥೆಯ ಹೆಸರು ಅಥವಾ ಕೋಡ್ ನಮೂದಿಸಿ',
    or: 'ಅಥವಾ',
    haveDirectLink: 'ನಿಮ್ಮ ಸಂಸ್ಥೆಯಿಂದ ನೇರ ಲಿಂಕ್ ಇದೆಯೇ?',
    useDirectLink: 'ಅವರು ಒದಗಿಸಿದ ಲಿಂಕ್ ಬಳಸಿ',
    privacyProtected: 'ನಿಮ್ಮ ಗೌಪ್ಯತೆ ಕಾನೂನಿನಿಂದ ರಕ್ಷಿಸಲ್ಪಟ್ಟಿದೆ',
    
    // Login flow
    phoneOrEmail: 'ಫೋನ್ ನಂಬರ್ ಅಥವಾ ಇಮೇಲ್',
    enterPhoneOrEmailPlaceholder: 'ನಿಮ್ಮ ನೋಂದಾಯಿತ ಫೋನ್ ಅಥವಾ ಇಮೇಲ್ ನಮೂದಿಸಿ',
    otpWillBeSent: 'ನಾವು ನಿಮಗೆ ಒನ್-ಟೈಮ್ ಪಾಸ್‌ವರ್ಡ್ (OTP) ಕಳುಹಿಸುತ್ತೇವೆ',
    sendOtp: 'OTP ಕಳುಹಿಸಿ',
    enterPhoneOrEmail: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಫೋನ್ ನಂಬರ್ ಅಥವಾ ಇಮೇಲ್ ನಮೂದಿಸಿ',
    otpSentTo: 'OTP ಕಳುಹಿಸಲಾಗಿದೆ',
    expiresIn: 'ಮುಕ್ತಾಯವಾಗುತ್ತದೆ',
    enterOtp: 'OTP ನಮೂದಿಸಿ',
    enterValidOtp: 'ದಯವಿಟ್ಟು ಮಾನ್ಯ OTP ನಮೂದಿಸಿ',
    verifyOtp: 'OTP ಪರಿಶೀಲಿಸಿ',
    resendOtp: 'OTP ಮರುಕಳುಹಿಸಿ',
    otpVerified: 'OTP ಪರಿಶೀಲಿಸಲಾಗಿದೆ',
    oneMoreStep: 'ನಿಮ್ಮ ಗುರುತನ್ನು ಪರಿಶೀಲಿಸಲು ಇನ್ನೂ ಒಂದು ಹಂತ',
    enterSecurityAnswer: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಉತ್ತರ ನಮೂದಿಸಿ',
    enterAnswer: 'ಉತ್ತರ ನಮೂದಿಸಿ',
    dobFormat: 'ಫಾರ್ಮ್ಯಾಟ್: DDMMYYYY (ಉದಾ., 15051990 ಮೇ 15, 1990)',
    login: 'ಲಾಗಿನ್',
    startOver: 'ಮತ್ತೆ ಪ್ರಾರಂಭಿಸಿ',
    needHelp: 'ಸಹಾಯ ಬೇಕೆ?',
    privacyNotice: 'ನಿಮ್ಮ ಡೇಟಾ ಅನ್ವಯವಾಗುವ ಗೌಪ್ಯತೆ ಕಾನೂನುಗಳ ಅಡಿಯಲ್ಲಿ ರಕ್ಷಿಸಲ್ಪಟ್ಟಿದೆ',
    checkUrlOrContact: 'ದಯವಿಟ್ಟು URL ಪರಿಶೀಲಿಸಿ ಅಥವಾ ನಿಮ್ಮ ಸಂಸ್ಥೆಯನ್ನು ಸಂಪರ್ಕಿಸಿ.',
    
    // Consent history
    filterAll: 'ಎಲ್ಲಾ',
    statusActive: 'ಸಕ್ರಿಯ',
    statusWithdrawn: 'ಹಿಂಪಡೆಯಲಾಗಿದೆ',
    statusExpired: 'ಅವಧಿ ಮುಗಿದಿದೆ',
    noConsents: 'ಒಪ್ಪಿಗೆ ದಾಖಲೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
    noConsentsWithFilter: 'ಈ ಸ್ಥಿತಿಯಲ್ಲಿ ಒಪ್ಪಿಗೆಗಳಿಲ್ಲ',
    consentedOn: 'ಒಪ್ಪಿಗೆ ನೀಡಿದ ದಿನಾಂಕ',
    expiresOn: 'ಮುಕ್ತಾಯ ದಿನಾಂಕ',
    withdrawnOn: 'ಹಿಂಪಡೆದ ದಿನಾಂಕ',
    withdrawConsent: 'ಒಪ್ಪಿಗೆ ಹಿಂಪಡೆಯಿರಿ',
    withdrawalHistory: 'ಹಿಂಪಡೆಯುವಿಕೆ ಇತಿಹಾಸ',
    help: 'ಸಹಾಯ',
    
    // Withdrawal
    cannotWithdraw: 'ಈ ಒಪ್ಪಿಗೆಯನ್ನು ಹಿಂಪಡೆಯಲು ಸಾಧ್ಯವಿಲ್ಲ',
    pleaseConfirmWithdrawal: 'ದಯವಿಟ್ಟು ಪರಿಣಾಮಗಳನ್ನು ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೀರಿ ಎಂದು ದೃಢೀಕರಿಸಿ',
    importantNotice: 'ಮುಖ್ಯ ಸೂಚನೆ',
    withdrawalNotice1: 'ಸಂಸ್ಥೆ ಹೇಳಿದ ಉದ್ದೇಶಗಳಿಗಾಗಿ ನಿಮ್ಮ ಡೇಟಾ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸುವುದನ್ನು ನಿಲ್ಲಿಸುತ್ತದೆ.',
    withdrawalNotice2: 'ಕಾನೂನು ಅನುಸರಣೆಗಾಗಿ ಕೆಲವು ಡೇಟಾ ಉಳಿಸಿಕೊಳ್ಳಬಹುದು.',
    withdrawalNotice3: 'ಕೆಲವು ಸೇವೆಗಳನ್ನು ಬಳಸಲು ನೀವು ಮತ್ತೆ ಒಪ್ಪಿಗೆ ನೀಡಬೇಕಾಗಬಹುದು.',
    withdrawalNotice4: 'ಅನ್ವಯವಾಗುವ ಕಾನೂನುಗಳ ಪ್ರಕಾರ ಪ್ರಕ್ರಿಯೆ ಸಮಯ 7-30 ದಿನಗಳು ತೆಗೆದುಕೊಳ್ಳಬಹುದು.',
    withdrawalReason: 'ಹಿಂಪಡೆಯುವಿಕೆಗೆ ಕಾರಣ',
    withdrawalReasonPlaceholder: 'ನೀವು ಏಕೆ ಹಿಂಪಡೆಯಲು ಬಯಸುತ್ತೀರಿ ಎಂದು ತಿಳಿಸಿ (ಐಚ್ಛಿಕ)',
    withdrawalConfirmation: 'ನನ್ನ ಒಪ್ಪಿಗೆಯನ್ನು ಹಿಂಪಡೆಯುವುದರಿಂದ ಕೆಲವು ಸೇವೆಗಳನ್ನು ಬಳಸುವ ನನ್ನ ಸಾಮರ್ಥ್ಯ ಪರಿಣಾಮ ಬೀರಬಹುದು ಎಂದು ನಾನು ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೇನೆ, ಮತ್ತು ಈ ವಿನಂತಿಯೊಂದಿಗೆ ಮುಂದುವರಿಯಲು ಬಯಸುತ್ತೇನೆ.',
    submitWithdrawalRequest: 'ಹಿಂಪಡೆಯುವಿಕೆ ವಿನಂತಿ ಸಲ್ಲಿಸಿ',
    withdrawalSubmitted: 'ಹಿಂಪಡೆಯುವಿಕೆ ವಿನಂತಿ ಸಲ್ಲಿಸಲಾಗಿದೆ',
    withdrawalSubmittedDesc: 'ನಿಮ್ಮ ಹಿಂಪಡೆಯುವಿಕೆ ವಿನಂತಿ ಸಲ್ಲಿಸಲಾಗಿದೆ. ಸಂಸ್ಥೆ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಿದ ನಂತರ ನಿಮಗೆ ತಿಳಿಸಲಾಗುವುದು.',
    processingTime: 'ಪ್ರಕ್ರಿಯೆ ಸಮಯ',
    days: 'ದಿನಗಳು',
    backToHistory: 'ಒಪ್ಪಿಗೆ ಇತಿಹಾಸಕ್ಕೆ ಹಿಂತಿರುಗಿ',
    
    // Withdrawal history
    statusPending: 'ಬಾಕಿ',
    statusApproved: 'ಅನುಮೋದಿಸಲಾಗಿದೆ',
    statusRejected: 'ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
    noWithdrawals: 'ಹಿಂಪಡೆಯುವಿಕೆ ವಿನಂತಿಗಳಿಲ್ಲ',
    viewConsents: 'ನಿಮ್ಮ ಒಪ್ಪಿಗೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
    requestedOn: 'ವಿನಂತಿಸಿದ ದಿನಾಂಕ',
    processedOn: 'ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಿದ ದಿನಾಂಕ',
    processingMessage: 'ನಿಮ್ಮ ವಿನಂತಿ ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿದೆ. ಪೂರ್ಣಗೊಂಡ ನಂತರ ನಿಮಗೆ ತಿಳಿಸಲಾಗುವುದು.',
    processingTimeInfo: 'ಪ್ರಕ್ರಿಯೆ ಸಮಯ ಮಾಹಿತಿ',
    
    // Help section
    yourRights: 'ನಿಮ್ಮ ಗೌಪ್ಯತೆ ಹಕ್ಕುಗಳು',
    helpTitle: 'ನಿಮ್ಮ ಗೌಪ್ಯತೆ ಹಕ್ಕುಗಳನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ',
    helpSubtitle: 'ಗೌಪ್ಯತೆ ಕಾನೂನುಗಳ ಅಡಿಯಲ್ಲಿ ನಿಮ್ಮ ಹಕ್ಕುಗಳು ಮತ್ತು ಒಪ್ಪಿಗೆಯನ್ನು ಹೇಗೆ ನಿರ್ವಹಿಸುವುದು ಎಂಬುದನ್ನು ತಿಳಿಯಿರಿ.',
    quickActions: 'ತ್ವರಿತ ಕ್ರಿಯೆಗಳು',
    viewMyConsents: 'ನನ್ನ ಒಪ್ಪಿಗೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
    viewWithdrawalRequests: 'ಹಿಂಪಡೆಯುವಿಕೆ ವಿನಂತಿಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
    loginToViewConsents: 'ನಿಮ್ಮ ಒಪ್ಪಿಗೆಗಳನ್ನು ವೀಕ್ಷಿಸಲು ಲಾಗಿನ್ ಮಾಡಿ',
    applicableLaws: 'ಅನ್ವಯವಾಗುವ ಗೌಪ್ಯತೆ ಕಾನೂನುಗಳು',
    
    // Rights FAQ
    rightAccessQ: 'ಪ್ರವೇಶ ಹಕ್ಕು ಎಂದರೇನು?',
    rightAccessA: 'ನಿಮ್ಮ ಬಗ್ಗೆ ಯಾವ ವೈಯಕ್ತಿಕ ಡೇಟಾ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತಿದೆ, ಅದನ್ನು ಹೇಗೆ ಬಳಸಲಾಗುತ್ತಿದೆ, ಯಾರೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳಲಾಗುತ್ತಿದೆ ಎಂದು ತಿಳಿಯುವ ಹಕ್ಕು ನಿಮಗಿದೆ.',
    rightCorrectQ: 'ತಿದ್ದುಪಡಿ ಹಕ್ಕು ಎಂದರೇನು?',
    rightCorrectA: 'ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಡೇಟಾ ತಪ್ಪಾಗಿದ್ದರೆ ಅಥವಾ ಅಪೂರ್ಣವಾಗಿದ್ದರೆ, ಅದನ್ನು ತಿದ್ದುಪಡಿ ಮಾಡಲು ಅಥವಾ ನವೀಕರಿಸಲು ವಿನಂತಿಸಬಹುದು.',
    rightWithdrawQ: 'ಒಪ್ಪಿಗೆ ಹಿಂಪಡೆಯುವ ಹಕ್ಕು ಎಂದರೇನು?',
    rightWithdrawA: 'ನೀವು ಯಾವಾಗ ಬೇಕಾದರೂ ನಿಮ್ಮ ಒಪ್ಪಿಗೆಯನ್ನು ಹಿಂಪಡೆಯಬಹುದು. ಹಿಂಪಡೆದ ನಂತರ, ನೀವು ಒಪ್ಪಿಗೆ ನೀಡಿದ ಉದ್ದೇಶಗಳಿಗಾಗಿ ನಿಮ್ಮ ಡೇಟಾ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸುವುದನ್ನು ಸಂಸ್ಥೆ ನಿಲ್ಲಿಸಬೇಕು.',
    rightEraseQ: 'ಅಳಿಸುವಿಕೆ ಹಕ್ಕು ಎಂದರೇನು?',
    rightEraseA: '"ಮರೆತುಬಿಡುವ ಹಕ್ಕು" ಎಂದೂ ಕರೆಯಲ್ಪಡುವ, ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಡೇಟಾವನ್ನು ಅಳಿಸಲು ವಿನಂತಿಸಬಹುದು. ಆದರೆ, ಕೆಲವು ಮಾಹಿತಿಯನ್ನು ಉಳಿಸಿಕೊಳ್ಳಲು ಕಾನೂನು ಕಾರಣಗಳಿರಬಹುದು.',
    
    // Withdrawal FAQ
    withdrawalFaq: 'ಹಿಂಪಡೆಯುವಿಕೆ ಪ್ರಕ್ರಿಯೆ',
    withdrawHowQ: 'ನನ್ನ ಒಪ್ಪಿಗೆಯನ್ನು ಹೇಗೆ ಹಿಂಪಡೆಯುವುದು?',
    withdrawHowA: 'ನಿಮ್ಮ ಖಾತೆಗೆ ಲಾಗಿನ್ ಮಾಡಿ, ಒಪ್ಪಿಗೆ ಇತಿಹಾಸಕ್ಕೆ ಹೋಗಿ, ಸಕ್ರಿಯ ಒಪ್ಪಿಗೆಯಲ್ಲಿ "ಒಪ್ಪಿಗೆ ಹಿಂಪಡೆಯಿರಿ" ಕ್ಲಿಕ್ ಮಾಡಿ.',
    withdrawTimeQ: 'ಹಿಂಪಡೆಯಲು ಎಷ್ಟು ಸಮಯ ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ?',
    withdrawTimeA: 'ಅನ್ವಯವಾಗುವ ಕಾನೂನುಗಳ ಪ್ರಕಾರ ಪ್ರಕ್ರಿಯೆ ಸಮಯಗಳು: DPDP ಕಾಯ್ದೆ (ಭಾರತ) - 7 ದಿನಗಳು, GDPR (EU) - 30 ದಿನಗಳು, CCPA (ಕ್ಯಾಲಿಫೋರ್ನಿಯಾ) - 45 ದಿನಗಳು.',
    withdrawEffectQ: 'ಒಪ್ಪಿಗೆ ಹಿಂಪಡೆದ ನಂತರ ಏನಾಗುತ್ತದೆ?',
    withdrawEffectA: 'ಹೇಳಿದ ಉದ್ದೇಶಗಳಿಗಾಗಿ ನಿಮ್ಮ ಡೇಟಾ ಬಳಸುವುದನ್ನು ಸಂಸ್ಥೆ ನಿಲ್ಲಿಸುತ್ತದೆ. ಕಾನೂನು ಅನುಸರಣೆಗಾಗಿ ಕೆಲವು ಡೇಟಾ ಉಳಿಸಿಕೊಳ್ಳಬಹುದು.',
    
    // Security FAQ
    securityFaq: 'ಖಾತೆ ಭದ್ರತೆ',
    loginSecureQ: 'ನನ್ನ ಲಾಗಿನ್ ಹೇಗೆ ಸುರಕ್ಷಿತ?',
    loginSecureA: 'ನಾವು 3-ಹಂತದ ಪರಿಶೀಲನೆ ಪ್ರಕ್ರಿಯೆ ಬಳಸುತ್ತೇವೆ: ನೋಂದಾಯಿತ ಫೋನ್/ಇಮೇಲ್‌ಗೆ OTP, ನಂತರ ಭದ್ರತಾ ಪ್ರಶ್ನೆ.',
    dataProtectQ: 'ನನ್ನ ಡೇಟಾ ಹೇಗೆ ರಕ್ಷಿಸಲ್ಪಟ್ಟಿದೆ?',
    dataProtectA: 'ಎಲ್ಲಾ ಡೇಟಾ ಟ್ರಾನ್ಸಿಟ್ ಮತ್ತು ರೆಸ್ಟ್‌ನಲ್ಲಿ ಎನ್‌ಕ್ರಿಪ್ಟ್ ಆಗಿದೆ. DPDP ಕಾಯ್ದೆ, GDPR ಮತ್ತು ಇತರ ಗೌಪ್ಯತೆ ನಿಯಮಗಳನ್ನು ಅನುಸರಿಸುತ್ತೇವೆ.',
    
    // Contact FAQ
    contactFaq: 'ಸಂಪರ್ಕ ಮತ್ತು ಬೆಂಬಲ',
    grievanceQ: 'ದೂರು ಹೇಗೆ ಸಲ್ಲಿಸುವುದು?',
    grievanceA: 'ಸಂಸ್ಥೆಯ ಡೇಟಾ ಪ್ರೊಟೆಕ್ಷನ್ ಆಫೀಸರ್ (DPO) ಅಥವಾ ದೂರು ಅಧಿಕಾರಿಯನ್ನು ಸಂಪರ್ಕಿಸಬಹುದು.',
    regulatorQ: 'ನಿಯಂತ್ರಣ ಪ್ರಾಧಿಕಾರ ಯಾರು?',
    regulatorA: 'ಭಾರತದಲ್ಲಿ, ಡೇಟಾ ಪ್ರೊಟೆಕ್ಷನ್ ಬೋರ್ಡ್ ಗೌಪ್ಯತೆ ದೂರುಗಳನ್ನು ನಿರ್ವಹಿಸುತ್ತದೆ. EU ನಲ್ಲಿ, ನಿಮ್ಮ ರಾಷ್ಟ್ರೀಯ ಡೇಟಾ ಪ್ರೊಟೆಕ್ಷನ್ ಅಥಾರಿಟಿಯನ್ನು ಸಂಪರ್ಕಿಸಬಹುದು.',
  },
}
;
